<script>
    import {activePickerSnippet, snippetFlip} from './gp-context-items';
    import jQuery from "jquery";
    import {onMount} from "svelte";
    import "./libs/jquery-ui.min.js";
    import "./libs/jquery.ui.touch-punch.min.js";

    export let snippet;
    let domThis;

    const maxHeightPX = 85;
    const minHeightPX = 25;
    $: itemSize = parseInt(snippet.height) < 200 ? parseInt(snippet.height) * (maxHeightPX - minHeightPX) / 200 + minHeightPX : maxHeightPX;
    $: gardenerSize = parseInt(snippet.height) > 240 ? 200 * maxHeightPX / parseInt(snippet.height) : null;

    function selectItem(el) {
        if (el.enabled)
        {
            if ($activePickerSnippet !== el)
            {
                $activePickerSnippet = el;
                $snippetFlip = false;
            }
        }
        else
            GPSettings.upgradeClass.showOnlyInPremium("plants");
    }

    onMount(() => {
        jQuery(domThis).find('img').draggable({
            opacity: 0.7,
            helper: function (el) {
                return jQuery(el.target).closest('.GPSnippetPickerItem').find('img').clone()
            },
            cursorAt: {bottom: -3, left: 0},
            start: (e, ui) => {
                selectItem(snippet);
                if ($snippetFlip) jQuery(ui.helper).addClass('ui-draggable-helper-flipped')
            },
            appendTo: "body"
        });
    })
</script>


<div on:click={() => selectItem(snippet)}
     role="button"
     class="list-group-item GPSnippetPickerItem"
     class:premiumDisabled={!snippet.enabled}
     class:enabled={snippet.enabled}
     class:selected={$activePickerSnippet===snippet}
     class:flipped={$snippetFlip}
     bind:this={domThis}>

    {#if gardenerSize}<img src="img/nicons/gardener.svg" class="GPSnippetPickerGardener" style="height:{gardenerSize}px">{/if}
    <img class="GPSnippetPickerImage" src="{snippet.thumbUrl}" style="max-height:{itemSize}px"/>
    <div class="GPSnippetPickerItemName">{@html snippet['name']}</div>
    {#if $activePickerSnippet===snippet}
        <a on:click={() => {GP.app.showDetailsOfItem($activePickerSnippet)}} class="helpIcon">
            <i class="fa fa-question-circle"></i>
        </a>
        {#if snippet.own}
            <a on:click={() => {let evt = new CustomEvent('deleteSnippet', {detail: $activePickerSnippet.id}); window.dispatchEvent(evt)}} class="deleteIcon">
                <i class="fa fa-minus-circle"></i>
            </a>
        {/if}
    {/if}
</div>